const Privacy = (history: any, location: any) => {

    const heading1 = {
        fontSize: "2rem",
        textAlign: "center" as const,
        marginBottom: "10px",
        color: "#111",
    };

    const heading2 = {
        fontSize: "1.4rem",
        marginTop: "30px",
        borderBottom: "2px solid #eee",
        paddingBottom: "5px",
        color: "#111",
    };

    const heading3 = {
        fontSize: "1.1rem",
        marginTop: "20px",
        color: "#222",
    };

    const paragraph = {
        margin: "10px 0",
    };

    const listStyle = {
        margin: "10px 0 10px 20px",
    };

    const effectiveDate = {
        textAlign: "center" as const,
        fontSize: "0.95rem",
        color: "#666",
        marginBottom: "20px",
    };

    const contactBox = {
        marginTop: "30px",
        padding: "15px",
        background: "#f9f9f9",
        borderRadius: "5px",
        border: "1px solid #eee",
    };

    return (
        <div style={{ width: '90%', margin: '0 auto', padding: '40px 0', color: '#171717' }}>
            <h1 style={heading1}>SNAPWIZ Privacy Policy</h1>
            <p style={effectiveDate}>
                <strong>Effective Date:</strong> 01.09.2024
            </p>

            <p style={paragraph}>
                Shah EternalGraphers Private Limited, operating under the brand name{" "}
                <strong>“SNAPWIZ”</strong> (hereinafter referred to as "SNAPWIZ",
                "Company", "we", "us", or "our"), is committed to protecting the privacy
                of users of our website{" "}
                <a href="https://www.snapwiz.in" target="_blank" rel="noopener noreferrer">
                    https://www.snapwiz.in
                </a>{" "}
                ("Website") and mobile application ("App"). This Privacy Policy
                ("Policy") describes how we collect, use, process, and disclose your
                personal information when you access or use our Website, App, or
                services (collectively, “Services”).
            </p>

            <p style={paragraph}>
                This Policy is subject to and incorporated by reference into the SNAPWIZ
                Terms of Use available at{" "}
                <a href="https://www.snapwiz.in/terms" target="_blank" rel="noopener noreferrer">
                    https://www.snapwiz.in/terms
                </a>
                .
            </p>

            <h2 style={heading2}>A. DEFINITIONS</h2>
            <ul style={listStyle}>
                <li>
                    <strong>Personal Data</strong> means any information that relates to an
                    identified or identifiable individual.
                </li>
                <li>
                    <strong>Service</strong> refers to the Website, App, and all services
                    provided by SNAPWIZ.
                </li>
                <li>
                    <strong>User</strong> means any individual or legal entity accessing or
                    using the Service.
                </li>
                <li>
                    <strong>Device</strong> means any device such as a mobile phone,
                    tablet, or computer used to access the Service.
                </li>
                <li>
                    <strong>Account</strong> means a unique account created by you to use
                    our Services.
                </li>
            </ul>

            <h2 style={heading2}>B. INFORMATION WE COLLECT</h2>
            <h3 style={heading3}>1. Personal Data You Provide</h3>
            <p style={paragraph}>We collect personal information when you:</p>
            <ul style={listStyle}>
                <li>Register an account (name, email, phone number, password)</li>
                <li>Provide address/location for services</li>
                <li>Post content such as reviews, feedback, or user profiles</li>
                <li>Contact customer support</li>
                <li>Participate in surveys or marketing campaigns</li>
            </ul>

            <h3 style={heading3}>2. Information from Social Media</h3>
            <p style={paragraph}>
                If you sign in via Google, Facebook, Instagram, or other third-party
                platforms, we may collect your basic profile details as authorized by
                you, such as:
            </p>
            <ul style={listStyle}>
                <li>Name, email, user ID, profile photo</li>
                <li>Contacts/friends list (if permission granted)</li>
                <li>Public posts relevant to service use</li>
            </ul>

            <h3 style={heading3}>3. Usage Data</h3>
            <p style={paragraph}>We automatically collect data such as:</p>
            <ul style={listStyle}>
                <li>IP address, browser type, device ID</li>
                <li>Access times, page views, referring URLs</li>
                <li>Device information (OS, app version, etc.)</li>
            </ul>

            <h3 style={heading3}>4. Cookies & Tracking Technologies</h3>
            <p style={paragraph}>
                We use session and persistent cookies, web beacons, tags, and scripts to
                analyze trends and administer the Service. Categories include:
            </p>
            <ul style={listStyle}>
                <li>Essential cookies: Necessary for basic functionality</li>
                <li>Analytics cookies: For traffic and usage patterns</li>
                <li>Functionality cookies: To remember preferences</li>
                <li>Advertising cookies: To deliver personalized ads via third-party networks</li>
            </ul>

            <h2 style={heading2}>C. HOW WE USE YOUR INFORMATION</h2>
            <ul style={listStyle}>
                <li>Deliver and manage the Services</li>
                <li>Personalize your experience</li>
                <li>Verify identity and prevent fraud</li>
                <li>Process payments via secure third-party gateways</li>
                <li>Provide customer support</li>
                <li>Send transactional and promotional communications</li>
                <li>Analyze service usage and improve features</li>
                <li>Comply with legal obligations</li>
            </ul>

            <h2 style={heading2}>D. DISCLOSURE OF YOUR INFORMATION</h2>
            <h3 style={heading3}>1. Service Providers</h3>
            <p style={paragraph}>
                With vetted third-party vendors that support our operations (hosting,
                payments, analytics, customer service). These parties are contractually
                bound to keep your data confidential.
            </p>
            <h3 style={heading3}>2. Legal Obligations</h3>
            <p style={paragraph}>
                When required by law, court order, or government request.
            </p>
            <h3 style={heading3}>3. Business Transfers</h3>
            <p style={paragraph}>
                If SNAPWIZ is involved in a merger, acquisition, or sale of assets, your
                information may be transferred as part of that transaction.
            </p>
            <h3 style={heading3}>4. Consent</h3>
            <p style={paragraph}>
                We may share your information with others when you give us explicit
                consent to do so.
            </p>

            <h2 style={heading2}>E. DATA RETENTION</h2>
            <ul style={listStyle}>
                <li>As long as your account is active</li>
                <li>
                    For as long as necessary to comply with legal obligations, resolve
                    disputes, and enforce agreements
                </li>
                <li>
                    Usage data is generally retained for shorter periods unless needed for
                    security or legal reasons
                </li>
            </ul>

            <h2 style={heading2}>F. YOUR PRIVACY RIGHTS</h2>
            <p style={paragraph}>You may:</p>
            <ul style={listStyle}>
                <li>Access, update, or delete your personal data through your Account settings</li>
                <li>Request a copy of your data</li>
                <li>Withdraw consent (where applicable)</li>
                <li>
                    Delete your Account by contacting support (note: we may retain some
                    information for compliance)
                </li>
            </ul>
            <p style={paragraph}>
                To exercise your rights, email us at{" "}
                <a href="mailto:contact@snapwiz.in">contact@snapwiz.in</a>
            </p>

            {/* Continue sections G to N in the same pattern */}

            <h2 style={heading2}>G. CONTACT US</h2>
            <div style={contactBox}>
                <p style={paragraph}>
                    Shah EternalGraphers Private Limited
                    <br />
                    406, 4th Floor, Shiv Darshan Co-op. Society,
                    <br />
                    Dhuswadi, Zaobawadi, Thakurdwar Road,
                    <br />
                    Mumbai - 400002, Maharashtra, India
                </p>
                <p style={paragraph}>
                    Email:{" "}
                    <a href="mailto:contact@snapwiz.in">contact@snapwiz.in</a>
                    <br />
                    Phone: +91 8828003230
                </p>
            </div>
        </div>
    )
}

export default Privacy;